import Register from './Register'
import RegisterClose from './RegisterClose'
import UserSubmit from './UserSubmit'
import ManageShop from './ManageShop'
import Home from './Home'
import EmClose from './EmClose.vue'
import NavbarRegister from './NavbarRegister.vue'
import CreateLineOAaccount from './CreateLineOAaccount.vue'

export default {
  Register,
  UserSubmit,
  RegisterClose,
  ManageShop,
  Home,
  EmClose,
  NavbarRegister,
  CreateLineOAaccount
}



// WEBPACK FOOTER //
// ./src/components/Welcome/index.js